<template>
  <v-combobox
    v-model="inputedValue"
    dense
    filled
    class="normalCombobox"
    :items="items"
    :height="height"
    :placeholder="$t(placeholder)"
    item-text="label"
    item-value="value"
    hide-details
    return-object
  />
</template>

<script>
// 幅の調整は親で行う
export default {
  name: 'NormalCombobox',
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    items: {},
    height: { default: '32px' },
    placeholder: { default: 'common.input_please-select' }
  },
  data: () => ({
    selecteditem: null
  }),
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.normalCombobox {
  ::v-deep .v-input__slot:before {
    border-style: none !important;
    border-width: 0 0 0 0 !important;
  }
  ::v-deep .v-input__slot {
    border-radius: 4px;
  }
  ::v-deep .v-input__append-inner {
    margin-top: 3px !important;
  }
}
</style>
